module.exports = __webpack_public_path__ + "img/icon_teacher_satisfaction_q.39b95cf0.svg";